import { useState } from "react";

import { AUTH_ROLES } from "api/common/types/auth.types";
import { useAuth } from "hooks/useAuth";

import DraftResponseToLab from "./components/DraftResponseToLab";
import InitialComments from "./components/InitialComments";
import Justification from "./components/Justification";
import OfficialResponseToLab from "./components/OfficialResponseToLab";

const EarAccordions = ({
  review,
  userCanEdit,
  setIsEditing,
  isEditing,
  handleChange,
  readOnly,
  ERTMember,
  setShowResponseModal,
}) => {
  const { permissions } = useAuth();
  const [textFieldUpdate, setTextFieldUpdate] = useState({});

  const isLab = permissions.role_type === AUTH_ROLES.LAB;
  const isPendingReviewOrDraft = ["Pending Review", "Draft"].includes(
    review.status,
  );

  const handleChangeTextField = (e) => {
    setTextFieldUpdate({ ...textFieldUpdate, [e.target.name]: e.target.value });
  };

  // Lab can only see the official response to lab
  return !isLab ? (
    <>
      <Justification
        review={review}
        userCanEdit={userCanEdit}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        handleChange={handleChange}
        handleChangeTextField={handleChangeTextField}
        textFieldUpdate={textFieldUpdate}
      />
      <InitialComments
        review={review}
        userCanEdit={userCanEdit}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
        handleChange={handleChange}
        handleChangeTextField={handleChangeTextField}
        textFieldUpdate={textFieldUpdate}
      />
      {isPendingReviewOrDraft ? (
        <DraftResponseToLab
          review={review}
          readOnly={readOnly}
          permissions={permissions}
          ERTMember={ERTMember}
          setShowResponseModal={setShowResponseModal}
        />
      ) : (
        <OfficialResponseToLab review={review} />
      )}
    </>
  ) : (
    <OfficialResponseToLab review={review} />
  );
};

export default EarAccordions;
